<template>
    <b-form
      :class="[inline ? 'gap-2 items-center' : '']"
      :inline="inline"
      @submit.prevent="onSubmit"
      @reset.prevent="clear"
      @reset="onReset"
      v-if="show">


      <b-form-group
        id="input-group-1"
        :label="$t('document_title')"
        label-for="document_title">
        <b-form-input
          id="document_title"
          v-model="item.title"
          class="required"
          disabled>
        </b-form-input>
      </b-form-group>


      <b-form-group
        id="input-group-2"
        :label="$t('document_category')"
        label-for="document_category">
        <b-form-select
          id="document-category"
          class="required-select"
          :options="documentCategories"
          text-field="name"
          value-field="id"
          v-model="item.document_category_id"
          disabled/>
      </b-form-group>

      <b-form-group
        id="input-group-3"
        :label="$t('document_description')"
        label-for="document_description">
        <div class="simple-content simple-editor simple-editor-disabled" v-html-safe="item.description"/>
      </b-form-group>
      <b-form-group id="input-group-4"
          :label="$t('document_password')"
          label-for="document_password" v-if="item.password" >
          <b-form-input
            id="document_password"
            v-model="item.password"
            disabled>
          </b-form-input>
        </b-form-group>

      <b-row class="m-0">
        <b-col
          lg="12">
          <h5 class="mt-2 mb-0">{{ $t('document_subtitle_document') }}</h5>
          <vs-divider></vs-divider>
        </b-col>
      </b-row>

      <b-row class="">
        <b-col md="12">
          <media-list :medias="files"
                      :show-delete="false"
                      :action-on-click="false"/>

          <div class="flex flex-row justify-end pb-1" v-if="files && files.length > 0">
            <b-button @click="downloadAll" v-permission="'documents.download_all'" variant="primary">
              <feather-icon
              icon="DownloadIcon"
              class="mr-50"/>
              <span class="align-middle">{{$t('action.download_all')}}</span>
            </b-button>
          </div>

          <div class="flex flex-row justify-center" v-if="!files || files.length == 0">
            {{$t('msg_none_file')}}
          </div>
        </b-col>
      </b-row>
    </b-form>
</template>

<script>

import SelectSuggestion from '@/components/SelectSuggestion.vue'
import {required, min, email} from '@validations'
import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BButton,
  BRow,
  BCol,
  VBTooltip,
} from 'bootstrap-vue'
import DocumentService from '@/services/api/DocumentService'
import MediaList from '@/components/media/MediaList.vue'
import SimpleEditor from '@/components/SimpleEditor.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    SelectSuggestion,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BButton,
    BRow,
    BCol,
    MediaList,
    SimpleEditor
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    service: null,
    item: {
      title: '',
      description: '',
      password: '',
      document_category_id: ''
    },
    documentCategory: {},
    documentCategories: [],
    files: [],
    show: true,
    required, email, min
  }),
  methods: {
    loadDocumentCategories() {
      return this.service.getCategories().then(
        response => {
          this.documentCategories = [
            ...response
          ]
        },
        error => {
          console.error('whoops')
        }
      )
    },
    onReset() {
      console.log('ret')
    },
    onSubmit() {

    },
    getData() {
      return this.service.read(this.id).then(
        response => {
          this.item.title = response.title
          this.item.description = response.description || ''
          this.item.password = response.password
          this.item.document_category_id = response.document_category_id
          this.files = response.files
        },
        error => {
          console.error('oh no!')
        }
      )
    },
    goBack() {
      this.$router.push({
        name: 'document-index'
      })
    },
    isEdit() {
      return (this.id != null || this.id != undefined)
    },
    downloadAll(){
      this.notifySuccess(this.$vs, 'Aguarde... processando sua solicitação!')

      this.service.getFilesDownloadLink(this.id).then(
        (data) => {
          this.notifySuccess(this.$vs, 'Iniciando Download...')
          const openTab = () => {this.$utils.browser.newTab(data.link)}
          openTab()
        },
        (error) => {
          this.notifyError(this.$vs, 'Erro! Não foi possível iniciar o download dos arquivos.')
        }
      )

      /*
      this.service.downloadAll(this.id, this.item.title+'.zip').then(
        (success) => {
          this.notifySuccess(this.$vs, 'Iniciando Download...')
        },
        (error) => {
          this.notifyError(this.$vs, 'Erro! Não foi possível iniciar o download dos arquivos.')
        }
      )
      */
    },

  },
  computed: {
    getFileUploadUrl() {
      const base = `${process.env.VUE_APP_API_BASE_URL}/api/v1`
      return `${base}/documents/${this.id}/files`
    },
  },
  beforeMount() {
    this.service = DocumentService.build(this.$vs)

    this.show = false
    const bootstrapRequests = []

    this.$vs.loading()

    bootstrapRequests.push(this.loadDocumentCategories())

    if (this.id) {
      bootstrapRequests.push(this.getData(this.id))
    }

    Promise.all(bootstrapRequests).then(
      () => this.show = true
    ).finally(
      () => this.$vs.loading.close()
    )
  },
}
</script>


<style lang="scss" scoped>
  @import 'src/assets/scss/simple-content.scss';

  ::v-deep .vs-popup {
    width: 800px !important;
  }
</style>
